import { CmsSectionShell } from './CmsSectionShell.tsx';
import { themeOf, EYEBROW, BUTTON_FILL } from './cmsTheme.ts';
import type { PlaylistSection } from '../../lib/types.ts';

/**
 * "Spotify Player" section (CMS-031). Editorial: the official playlist URL is authored in the
 * BackOffice, not sourced from program.json. Omitted entirely when no URL is authored (per
 * program-sections.feature).
 *
 * v2 shape: one card, copy on the left and the CTA on the right (stacked on mobile). The button
 * takes the section's own filled-control color rather than Spotify green — the glyph already says
 * where the link goes, and the brand green clashes with half the combinations.
 */
export function CmsPlaylistSection({ theme, guitar, url }: PlaylistSection) {
  if (!url) return null;

  const t = themeOf(theme);

  return (
    <CmsSectionShell theme={theme} guitar={guitar}>
      <div className={`rounded-card p-6 md:p-8 ${t.card.bg} ${t.card.text} flex flex-col gap-6 md:flex-row md:items-center md:justify-between md:gap-10`}>
        <div className="md:flex-1">
          <div className={`${EYEBROW} ${t.eyebrow} mb-2`}>Spilleliste</div>
          <h2 className="font-display text-3xl md:text-[40px] leading-none tracking-[-0.02em]">
            Den officielle spilleliste
          </h2>
          <p className={`mt-3 max-w-xl leading-relaxed ${t.card.muted}`}>
            Alle årets kunstnere samlet i én playliste. Perfekt til at varme op inden festivalen –
            eller genopleve stemningen bagefter.
          </p>
        </div>
        <a
          href={url}
          target="_blank"
          rel="noreferrer"
          className={`inline-flex shrink-0 items-center gap-3 rounded-full px-6 py-3 font-medium transition-colors ${BUTTON_FILL[t.button]}`}
        >
          <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm4.6 14.4c-.2.3-.5.4-.8.2-2.2-1.3-4.9-1.6-8.2-.9-.3.1-.6-.1-.7-.4-.1-.3.1-.6.4-.7 3.5-.8 6.6-.4 9 1.1.3.2.4.5.3.7zm1.2-2.7c-.2.4-.6.5-1 .3-2.5-1.5-6.3-2-9.3-1.1-.4.1-.8-.1-.9-.5-.1-.4.1-.8.5-.9 3.4-1 7.6-.5 10.5 1.2.4.2.5.6.2 1zm.1-2.8c-3-1.8-8-1.9-10.9-1-.5.1-.9-.2-1-.6-.1-.5.2-.9.6-1 3.3-1 8.8-.8 12.2 1.2.4.3.6.8.3 1.2-.2.4-.8.5-1.2.2z" />
          </svg>
          Åbn på Spotify
        </a>
      </div>
    </CmsSectionShell>
  );
}
